import React from 'react';

const CrossIcon = () => {
  return (
    <div className="vbz-icon-beneficiaries">
      <div className="vbz-icon-beneficiaries-cross" />
    </div>
  );
};

export default CrossIcon;
